import { render } from "./HeaderView.vue?vue&type=template&id=4ef54c11"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=4ef54c11&lang=scss"

import exportComponent from "/var/www/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__